import { InjectionToken } from '@angular/core';
import { Observable } from 'rxjs';
import { Comment } from '@k12/models';
import { EmployeeSummary, EmployeeSummaryAdminPayload } from '@k12/models';
import {
  IssueHistory,
  IssueRecordFilter,
  IssueTrackingPayload
} from '@k12/models';
import { AccountMessageTopic, ProviderAndTopicListResponse } from '@k12/models';
import {
  Address,
  AdminUserType,
  CommunicationTableItem,
  CommunicationTableMetadata,
  Paged,
  SubService,
} from '@k12/models';

export interface IUserRecordCommentsService {
  getComments(programPartnerId: string, commentType: number): Observable<Comment[]>;
}

export const USER_RECORD_COMMENTS_SERVICE = new InjectionToken<IUserRecordCommentsService>(
  'UserRecordCommentsService'
);

export interface IUserRecordCommunicationsService {
  getDashboardCommunicationGrid(
    payload: CommunicationTableMetadata
  ): Observable<Paged<CommunicationTableItem>>;
}

export const USER_RECORD_COMMUNICATIONS_SERVICE = new InjectionToken<IUserRecordCommunicationsService>(
  'UserRecordCommunicationsService'
);

export interface IUserRecordEmployeeService {
  GetAllEmployeesSummaryAdmin(
    programPartnerId: string,
    payload?: EmployeeSummaryAdminPayload
  ): Observable<EmployeeSummary[]>;
}

export const USER_RECORD_EMPLOYEE_SERVICE = new InjectionToken<IUserRecordEmployeeService>(
  'UserRecordEmployeeService'
);

export interface IUserRecordMessagesService {
  getProvidersAndTopicsList(): Observable<ProviderAndTopicListResponse>;
  getAccountMessageTopics(programPartnerId: string): Observable<AccountMessageTopic[]>;
}

export const USER_RECORD_MESSAGES_SERVICE = new InjectionToken<IUserRecordMessagesService>(
  'UserRecordMessagesService'
);

export interface IUserRecordSystemService {
  isoDateToFormatted(isoString: unknown): string;
}

export const USER_RECORD_SYSTEM_SERVICE = new InjectionToken<IUserRecordSystemService>(
  'UserRecordSystemService'
);

export interface IUserRecordProviderDetailsService {
  getProviderDetails(userId: string, userType: AdminUserType): Observable<unknown>;
  parseProviderAddress(address: Address | null | undefined): string;
  parseServices(services: SubService[]): string[];
}

export const USER_RECORD_PROVIDER_DETAILS_SERVICE =
  new InjectionToken<IUserRecordProviderDetailsService>('UserRecordProviderDetailsService');

export interface IUserRecordEditService {
  getSubServices(employeeType?: number): Observable<SubService[]>;
  editProviderDetails(payload: unknown): Promise<Observable<unknown>>;
}

export const USER_RECORD_EDIT_SERVICE = new InjectionToken<IUserRecordEditService>(
  'UserRecordEditService'
);

export interface IIssueTrackingService {
  getIssueRecords(filter: IssueRecordFilter): Observable<IssueHistory[]>;
  getIssueRecordsPageForUserRecord(filter: IssueRecordFilter): Observable<IssueHistory[]>;
  saveIssueTracking(payload: IssueTrackingPayload): Observable<IssueHistory>;
}

export const ISSUE_TRACKING_SERVICE = new InjectionToken<IIssueTrackingService>('IssueTrackingService');
